module.exports = __webpack_public_path__ + "5b5f81509d576b9d80df256b1f9a5943.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/style/fonts/GT-Walsheim-Pro-Bold.ttf
// module id = 400
// module chunks = 0